import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Injectable } from '@nestjs/common';
import { FolderSummary, FormCategory, FormStatus, FormSummary, ParentFolder, SpaceObjects, Tag, TagSetting } from '../../../../core';
export var SpaceApiMapper = (_dec = Injectable(), _dec(_class = /*#__PURE__*/function () {
  function SpaceApiMapper() {
    _classCallCheck(this, SpaceApiMapper);
  }

  _createClass(SpaceApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var parentFolders = dto.parentFolders,
          folders = dto.folders,
          forms = dto.forms;

      try {
        var _dto$nextToken, _dto$formNextToken, _dto$folderNextToken;

        var parentFoldersObjects = [];

        if (parentFolders) {
          parentFoldersObjects = parentFolders.map(function (parentFolderDto) {
            var id = parentFolderDto.id,
                title = parentFolderDto.title,
                level = parentFolderDto.level;
            return ParentFolder.create({
              id: id,
              level: level,
              title: title
            }).getValue();
          });
        }

        var folderSummaries = [];

        if (folders) {
          folderSummaries = folders.map(function (folderDto) {
            var id = folderDto.id,
                title = folderDto.title,
                parentId = folderDto.parentId;
            return FolderSummary.create({
              id: id,
              title: title,
              parentId: parentId
            }).getValue();
          });
        }

        var formSummaries = [];

        if (forms) {
          formSummaries = forms.map(function (formDto) {
            var props = {
              id: formDto.id,
              title: formDto.title,
              description: formDto.description,
              folderId: formDto.folderId,
              status: FormStatus.Active,
              updatedAt: formDto === null || formDto === void 0 ? void 0 : formDto.updatedAt,
              createdBy: formDto === null || formDto === void 0 ? void 0 : formDto.createdBy,
              thumbnail: formDto.thumbnail,
              coverImage: formDto.coverImage,
              totalQuestions: formDto.totalQuestions,
              totalScore: formDto.totalScore
            };

            if (formDto.category) {
              props.category = FormCategory.create({
                id: formDto.category.id,
                key: formDto.category.key,
                status: formDto.category.status,
                possibleQuestionCreationTypes: formDto.category.possibleQuestionCreationTypes,
                tagSettings: formDto.category.tagSettings ? formDto.category.tagSettings.map(function (tag) {
                  return TagSetting.create(_objectSpread({}, tag)).getValue();
                }) : []
              }).getValue();
            }

            if (formDto.tags) {
              props.tags = formDto.tags.map(function (tag) {
                return tag && Tag.create({
                  id: tag.id.toString(),
                  key: tag.key,
                  icon: tag.icon
                }).getValue();
              }).filter(function (tag) {
                return !!tag;
              });
            }

            return FormSummary.create(props).getValue();
          });
        }

        var props = {
          parentFolders: parentFoldersObjects,
          folders: folderSummaries,
          forms: formSummaries,
          nextToken: (_dto$nextToken = dto.nextToken) !== null && _dto$nextToken !== void 0 ? _dto$nextToken : null,
          formNextToken: (_dto$formNextToken = dto.formNextToken) !== null && _dto$formNextToken !== void 0 ? _dto$formNextToken : null,
          folderNextToken: (_dto$folderNextToken = dto.folderNextToken) !== null && _dto$folderNextToken !== void 0 ? _dto$folderNextToken : null
        };
        return SpaceObjects.create(props).getValue();
      } catch (error) {
        throw error;
      }
    }
  }]);

  return SpaceApiMapper;
}()) || _class);